import { FC, useEffect, useState } from 'react'
import { KTIcon } from '../../../../helpers'
import { useLayout } from '../../../../layout/core'

type WithdrawalType = {
  id: string
  name: string
  payairoTag: string
  type: string
  amount: number
  status: string
  date: string
  method: string
  email: string
  tag: string
  createdAt: string
  completedAt?: string
}

const DrawerWithdrawHistory: FC = () => {
  const { uuidOfWithdraw } = useLayout()
  const [withdrawDetails, setWithdrawDetails] = useState<WithdrawalType | null>(null)

  useEffect(() => {
    if (uuidOfWithdraw) {
      setWithdrawDetails(uuidOfWithdraw)
    }
  }, [uuidOfWithdraw])

  return (
    <div
      id='withdraw-details-drawer'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='withdraw-details'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'lg': '600px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#withdraw-details-drawer-toggle'
      data-kt-drawer-close='#withdraw-details-close'
    >
      <div className='card rounded-0 w-100'>
        {/* Header */}
        <div className='card-header'>
          <h3 className='card-title fw-bolder text-dark'>Withdraw Details</h3>
          <div className='card-toolbar'>
            <button
              type='button'
              id='withdraw-details-close'
              aria-label='Close panel'
              className='btn btn-icon btn-sm rounded-circle w-40px h-40px d-flex align-items-center justify-content-center'
              style={{
                backgroundColor: '#FFECEC',
                border: '1px solid #FFD1D1',
                boxShadow: '0 4px 12px rgba(220, 38, 38, 0.12)',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#FEE2E2'
                e.currentTarget.style.transform = 'scale(1.06)'
                e.currentTarget.style.boxShadow = '0 6px 16px rgba(220, 38, 38, 0.18)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#FFECEC'
                e.currentTarget.style.transform = 'scale(1)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.12)'
              }}
            >
              <KTIcon iconName='cross' className='fs-2 text-danger' />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className='card-body'>
          {!withdrawDetails ? (
            <div className='text-center py-10'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : (
            <div className='d-flex flex-column gap-5'>
              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>User Email:</span>
                <span className='fw-semibold text-dark'>{withdrawDetails.email}</span>
              </div>

              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>User Tag:</span>
                <span className='fw-semibold text-dark'>{withdrawDetails.payairoTag}</span>
              </div>

              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>Transaction ID:</span>
                <span className='fw-semibold text-dark'>{withdrawDetails.id}</span>
              </div>

              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>Amount:</span>
                <span className='fw-semibold text-dark'>{withdrawDetails.amount}</span>
              </div>

              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>Method:</span>
                <span className='fw-semibold text-dark'>{withdrawDetails.method}</span>
              </div>

              <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                <span className='fw-bold fs-6 text-gray-600'>Created At:</span>
                <span className='fw-semibold text-dark'>
                  {new Date(withdrawDetails.createdAt).toLocaleString()}
                </span>
              </div>

              {withdrawDetails.completedAt && (
                <div className='d-flex align-items-center justify-content-between border-bottom pb-3'>
                  <span className='fw-bold fs-6 text-gray-600'>Completed At:</span>
                  <span className='fw-semibold text-dark'>
                    {new Date(withdrawDetails.completedAt).toLocaleString()}
                  </span>
                </div>
              )}

              <div className='d-flex align-items-center justify-content-between'>
                <span className='fw-bold fs-6 text-gray-600'>Status:</span>
                <span
                  className={`badge ${withdrawDetails.status === 'Completed'
                    ? 'badge-light-success'
                    : withdrawDetails.status === 'Pending'
                      ? 'badge-light-warning'
                      : 'badge-light-danger'
                    } fw-semibold`}
                >
                  {withdrawDetails.status}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export { DrawerWithdrawHistory }
